import { OwnerAvatars } from "@/components/OwnerAvatars";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import { type PortfolioMatrixJob } from "@/hooks/queries/portfolio/useGetPortfolioMatrix";

export const StafferCell = ({
  job,
}: {
  job: Pick<PortfolioMatrixJob, "stafferIds">;
}) => {
  const { userInitialsMap } = useTaggableUsers();

  return (
    <OwnerAvatars
      ownerUserIds={job.stafferIds.slice(0, 3)}
      userInitialsMap={userInitialsMap}
    />
  );
};
